export const jewelleryFindingsLevelTwo = [
    {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Clasps",
        "categoryId": "clasps"
    },
    {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Jump Ring",
        "categoryId": "jump_ring"
    },
    {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Earrings Making Parts",
        "categoryId": "earrings_making_parts"
    },
    {
        "parentCategoryId": "jewellery_findings",
        "level": 2,
        "name": "Eye & Head Pins",
        "categoryId": "eye_n_head_pins"
    }

]
